<div class="duration-picker-container">
  <!-- Loading state -->
  @if (loading) {
    <div class="loading-indicator">
      Lade verfügbare Zeiten...
    </div>
  } @else if (!courtRows.length) {
    <!-- No courts message -->
    <div class="no-durations-message">
      Keine Spielzeiten verfügbar. Bitte wähle einen anderen Tag oder Platztyp.
    </div>
  } @else {
    <!-- Per-court rows with duration buttons -->
    <div class="court-rows">
      @for (row of courtRows; track row.courtId) {
        <div
          class="court-row"
          [class.selected]="isRowSelected(row)"
          [class.fully-booked]="row.fullyBooked">

          <div class="court-row-header">
            <span class="court-name">{{ row.courtName }}</span>
            @if (row.fullyBooked) {
              <span class="booked-label">{{ row.blocked ? 'gesperrt' : 'belegt' }}</span>
            }
          </div>

          @if (!row.fullyBooked) {
            <div class="duration-buttons">
              @for (option of row.options; track option.duration) {
                <button
                  type="button"
                  class="duration-button"
                  [class.selected]="isOptionSelected(row, option)"
                  [class.unavailable]="!option.available"
                  [disabled]="!option.available"
                  (click)="selectOption(row, option)">
                  <span class="duration-label">{{ option.duration }} min</span>
                  <span class="duration-price">{{ option.available ? formatPrice(option.price) : '—' }}</span>
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
